export default {
  CONTENT_API: '//content.api.qa.dice-tools.com/',
  OP_API: '//op.api.qa.dice-tools.com/',
  ERP_API: '//erp.api.qa.dice-tools.com/',
  CUSTOMER_API: '//customer-contact.api.qa.dice-tools.com/',
  ACCOUNTS_API: '//accounts.api.qa.dice-tools.com/',
  SUBSCRIPTIONS_API: '//subscriptions.api.qa.dice-tools.com/',
  IAM_API: '//iam.api.qa.dice-tools.com/',
  DPMM_API: '//dpmm.api.qa.dice-tools.com/',
  SALESFORCE_NA: '//doosan-nao--nauat.sandbox.my.site.com/dealernet/',
  SALESFORCE_EMEA: '//doosanbobcateu--uat.sandbox.my.site.com/bobcat/',
  MAGNOLIA_AUTHOR: '//magnolia-cms.qa.dice-tools.com/',
  MAGNOLIA_PUBLIC: '//magnolia-public.qa.dice-tools.com/',
  NGPASSPORT_API: '//adminenigma.api.qa.dice-tools.com/',
  SERVICE_AI: '//service-ai-v2-session-api.gdsqa.dice-tools.com/',
  AGENT_AI: '//bedrock-agentcore.us-east-1.amazonaws.com/runtimes/serviceaiv2chat-eYa7drDzz7/invocations?accountId=474668383292&qualifier=stable'
}
